function hashchange(event) {
	var page = location.hash.slice(1) || 'main',
		menu = $('#gdocs-menu'),
		li_page = $('#page_' + page);

	$('.sel', menu).removeClass('sel');
	li_page.addClass('sel');

	if (page)
	{
		event.preventDefault();
		$.ajax({
			method: "post",
			url: "/gdocs/" + page,
			dataType: 'html',
			success : function(data, errors) {
				$('#gdocs-main').html(data);
			}
		});
	}
}
window.addEventListener('hashchange', hashchange);
if(typeof(Event) === 'function') {
	var event = new Event("hashchange");
}else{
	var event = document.createEvent('Event');
	event.initEvent("hashchange", true, true);
}

window.dispatchEvent(event);
